export default "__VITE_ASSET__1475384d__"